// extracted by mini-css-extract-plugin
export default {"accordion":"permission_accordion__A1Inj","transparent":"permission_transparent__p0EYF","accordionheader":"permission_accordionheader__wkYff"};